import { BuffetIcon } from './BuffetIcon';

/**
 * author: nilsfast
 * id B68F24D9-0E45-4729-9DB9-46E0D73589F2
 * name buffet
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/buffet.svg
 * tags
 * - Home Automation 
 */
export const SideboardIcon = BuffetIcon;
export default SideboardIcon